module.exports = __webpack_public_path__ + "img/avatar.3232b437.png";